module.exports = __webpack_public_path__ + "static/media/la-picture-3.b0fd580f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Themes/LA/la-picture-3.jpg
// module id = 768
// module chunks = 1